import 'babel-polyfill'

var list_app = require('./list_app.js');
var detail_app = require('./detail_app.js');
var map = require('./map.js');
var index = require('./index.js');
var footer = require('./footer.js');
var edit_app = require('./edit.js');